import { render, staticRenderFns } from "./game-viewer.vue?vue&type=template&id=18824609&scoped=true&"
import script from "./game-viewer.vue?vue&type=script&lang=js&"
export * from "./game-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18824609",
  null
  
)

export default component.exports